import { render, staticRenderFns } from "./Sistema.vue?vue&type=template&id=32fa50fe"
import script from "./Sistema.vue?vue&type=script&lang=js"
export * from "./Sistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports